import { render, staticRenderFns } from "./DuplicateAssetModal.vue?vue&type=template&id=b287b2ca&scoped=true&"
import script from "./DuplicateAssetModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateAssetModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateAssetModal.vue?vue&type=style&index=0&id=b287b2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b287b2ca",
  null
  
)

export default component.exports